import * as uuid from "uuid";
import {toBoolean, toString} from "../helpers/helpers";

export class AreaGroupModel {
  static FLAGS = [
    "doUsageCollection",
    "doTonerMonitoring",
    "doTonerAutoOrder",
    "doInkMonitoring",
    "doInkAutoOrder",
    "doPrintHeadMonitoring",
    "doPrintHeadAutoOrder",
    "doMaintenanceMonitoring",
    "doMaintenanceAutoOrder",
    "doFastenerMonitoring",
    "doFastenerAutoOrder",
    "itsmConsumableAutoFulfillment",
    "itsmLongLifeConsumableAutoFulfillment",
  ];

  localId: string;
  id: string;
  areaName: string;
  areaITSMId: string;
  groupITSMId: string;
  groupName: string;
  asmCheckedDate: string;
  doUsageCollection: boolean;
  doTonerMonitoring: boolean;
  doTonerAutoOrder: boolean;
  doInkMonitoring: boolean;
  doInkAutoOrder: boolean;
  doPrintHeadMonitoring: boolean;
  doPrintHeadAutoOrder: boolean;
  doMaintenanceMonitoring: boolean;
  doMaintenanceAutoOrder: boolean;
  doFastenerMonitoring: boolean;
  doFastenerAutoOrder: boolean;
  itsmConsumableAutoFulfillment?: boolean;
  itsmLongLifeConsumableAutoFulfillment?: boolean;

  hasVerificationContactUploader: boolean;
  hasExceptionContactUploader: boolean;
  hasConsumableAddressUploader: boolean;
  hasServiceAddressUploader: boolean;
  disableEditReasons: string;

  duplicate: boolean;
  itsmDuplicate: boolean;
  areaNameRequired: boolean;
  groupNameRequired: boolean;

  areaDisabled: boolean;
  groupDisabled: boolean;

  addedToProject: boolean;

  projectId: string;
  allowEdit: boolean;
  existsInITSM: boolean;
  duplicateGroup: boolean;
  createdAt: string;
  updatedAt: string;

  get canonicalGroupName() {
    return this.groupName.toLowerCase();
  }

  get canonicalAreaName() {
    return this.areaName.toLowerCase();
  }

  get key() {
    return JSON.stringify([this.canonicalAreaName, this.canonicalGroupName]);
  }

  static converter = (json?: any) => new AreaGroupModel(json);

  constructor(json?: any) {
    json = json || {};

    this.localId = uuid.v1();
    this.id = toString(json.id);
    this.areaName = toString(json.areaName) || "";
    this.areaITSMId = toString(json.areaITSMId) || toString(json.areaId) || "";
    this.groupName = toString(json.groupName) || "";
    this.groupITSMId = toString(json.groupITSMId) || toString(json.groupId) || "";
    this.asmCheckedDate = parseDateFromJSON(json.asmCheckedDate) || null;

    this.doUsageCollection = toBoolean(json.doUsageCollection, true);
    this.doTonerMonitoring = toBoolean(json.doTonerMonitoring);
    this.doTonerAutoOrder = toBoolean(json.doTonerAutoOrder);
    this.doInkMonitoring = toBoolean(json.doInkMonitoring);
    this.doInkAutoOrder = toBoolean(json.doInkAutoOrder);
    this.doPrintHeadMonitoring = toBoolean(json.doPrintHeadMonitoring);
    this.doPrintHeadAutoOrder = toBoolean(json.doPrintHeadAutoOrder);
    this.doMaintenanceMonitoring = toBoolean(json.doMaintenanceMonitoring);
    this.doMaintenanceAutoOrder = toBoolean(json.doMaintenanceAutoOrder, true);
    this.doFastenerMonitoring = toBoolean(json.doFastenerMonitoring);
    this.doFastenerAutoOrder = toBoolean(json.doFastenerAutoOrder);
    this.itsmConsumableAutoFulfillment = toBoolean(json.itsmConsumableAutoFulfillment, true);
    this.itsmLongLifeConsumableAutoFulfillment = toBoolean(json.itsmLongLifeConsumableAutoFulfillment, true);

    this.hasVerificationContactUploader = toBoolean(json.hasVerificationContactUploader, true);
    this.hasExceptionContactUploader = toBoolean(json.hasExceptionContactUploader, true);
    this.hasConsumableAddressUploader = toBoolean(json.hasConsumableAddressUploader, true);
    this.hasServiceAddressUploader = toBoolean(json.hasServiceAddressUploader, true);
    this.disableEditReasons = toString(json.disableEditReasons) || "";

    this.areaDisabled = toBoolean(json.areaDisabled);
    this.groupDisabled = toBoolean(json.groupDisabled);

    this.addedToProject = toBoolean(json.addedToProject);

    this.duplicate = toBoolean(json.duplicate);
    this.itsmDuplicate = toBoolean(json.itsmDuplicate);
    this.areaNameRequired = toBoolean(json.areaNameRequired);
    this.groupNameRequired = toBoolean(json.groupNameRequired);

    this.projectId = toString(json.projectId);

    this.allowEdit = toBoolean(json.allowEdit, true);
    this.existsInITSM = toBoolean(json.existsInITSM, false);
    this.duplicateGroup = toBoolean(json.duplicateGroup, false);
    this.createdAt = json.createdAt;
    this.updatedAt = json.updatedAt;
  }

  clean() {
    this.areaName = this.areaName ? this.areaName.trim() : "";
    this.groupName = this.groupName ? this.groupName.trim() : "";
  }
}

function parseDateFromJSON(date) {
  if (!date) return null;
  const matches = `${date}`.match(/^([0-9]{4}-[0-9]{2}-[0-9]{2})T?/i);
  if (!matches) return null;
  return matches[1] || null;
}

export function areaGroupModelFactory(json?: any): AreaGroupModel {
  return new AreaGroupModel(json);
}
